import { render, staticRenderFns } from "./qPriceFormatted.vue?vue&type=template&id=5941896e&"
import script from "./qPriceFormatted.vue?vue&type=script&lang=ts&"
export * from "./qPriceFormatted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports